import type { z } from 'zod';
import type { HostKind } from '#util/host.ts';
import { advancedFormPartSchema } from './advanced/schema.ts';
import { makeHostGeneralFormPartSchema } from './general/schema.ts';

export const makeHostFormSchema = (kind: HostKind, v4CIDRs: readonly string[], v6CIDRs: readonly string[]) =>
  makeHostGeneralFormPartSchema(kind, v4CIDRs, v6CIDRs).and(advancedFormPartSchema);

export type HostFormData = z.input<ReturnType<typeof makeHostFormSchema>>;
export type HostFormTransformedData = z.infer<ReturnType<typeof makeHostFormSchema>>;
